import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";

// Components
import Heading from "../../shared/Heading";
import HomeForm from "./HomeForm";

// Services
import { createHome, uploadHomeImages } from "../../../services/Firebase";
import { isConnectedAccount } from "../../../other/Utilities";
import { UserContext } from "../../../other/Contexts";

function CreateHome() {
  const navigate = useNavigate();
  const userData = useContext(UserContext);
  const [images, setImages] = useState([]);
  const [progress, setProgress] = useState(0);
  const [submittingInProgress, setSubmittingInProgress] = useState(false);

  const sendForm = async (homeNew, imagesNew) => {
    const homeIdNew = await createHome(homeNew);
    await uploadHomeImages(homeIdNew, imagesNew, setProgress);
    navigate("/account/home-dashboard/" + homeIdNew);
  };

  return (
    <Container
      className="mainContainer"
      style={{ marginBottom: 40, maxWidth: 800, minWidth: 350 }}
    >
      <Heading text={"Create a new accommodation"} />
      <HomeForm
        editMode={false}
        progress={progress}
        submittingInProgress={submittingInProgress}
        setSubmittingInProgress={setSubmittingInProgress}
        isConnectedAccount={userData ? isConnectedAccount(userData) : false}
        home={null}
        images={images}
        setImages={setImages}
        sendForm={sendForm}
      />
    </Container>
  );
}

export default CreateHome;
